import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'vote-toggle',
  templateUrl: './vote-toggle.component.html',
  styleUrls: ['./vote-toggle.component.scss']
})
export class VoteToggleComponent implements OnInit {

  @Input() options: any[] = [{ name: "Yes", odds:0.5 }, { name: "No", odds:0.5 }];
  @Input() optionPayouts: any[];
  @Input() selectedIndex: number;
  @Input() fullBleed = false;
  @Output() didVote: EventEmitter<any> = new EventEmitter();

  public maxOdds: number = 0;
  public minOdds: number = 1.0;

  constructor() { }

  ngOnInit() {
    this.updateMaxOdds();
  }

  ngOnChanges() {
    this.updateMaxOdds();
    //this.selectedIndex = -1;
    //console.log("asdf");
  }

  updateMaxOdds() {
    this.maxOdds = 0;
    this.minOdds = 1.0;
    for(let option of this.options) {
      this.maxOdds = (option.odds > this.maxOdds) ? option.odds : this.maxOdds;
      this.minOdds = (option.odds < this.minOdds) ? option.odds : this.minOdds;
    }
  }

  didClick(index) {
    if(this.selectedIndex > -1) return;
    this.selectedIndex = index;
    this.didVote.emit(index);
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/vote-toggle/vote-toggle.component.ts